<div
  class="wrapper"
  >
  @if (paginatedFilteredSites?.length) {
    @for (site of paginatedFilteredSites; track site) {
      <app-site-reports-panel [site]="site" />
    }
  } @else {
    <div class="no-data flex justify-center items-center">
      No sites available for the current selection.
    </div>
  }
  <app-paginator
    (pageChanged)="onPageChanged($event)"
    [itemsPerPage]="itemsPerPage"
    [totalItems]="filteredSites?.length"
    class="paginator"
    >
  </app-paginator>
</div>
